/**
 * Tela em branco no iPhone depois de cada publicação. [Pablo 2026-10-21]
 *
 * "Teve cliente reclamando que não estava funcionando" (iOS). Cada tela é um
 * arquivo carregado sob demanda; publicar troca os arquivos e o app do iPhone
 * (que fica aberto por dias) pede o arquivo antigo, que não existe mais. Sem
 * tratamento, o React desmonta tudo e sobra a tela em branco.
 *
 * - `lazyComRecarga`: falhou ao baixar a tela → recarrega a página UMA vez
 *   (trava em sessionStorage, liberada depois que uma tela carrega).
 * - `LimiteDeErro`: qualquer erro de tela vira uma mensagem com "Recarregar",
 *   nunca a tela em branco.
 */
import React from 'react';

const CHAVE = 'app_recarregou_chunk';

/** Erro de "não consegui baixar o arquivo da tela". PURA. */
export function ehFalhaDeCarregamento(err) {
  const s = `${err && err.name} ${err && err.message}`;
  return /ChunkLoadError|Loading (CSS )?chunk|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unexpected token '<'/i.test(s);
}

function _ler() { try { return sessionStorage.getItem(CHAVE); } catch (_) { return '1'; } }
function _gravar(v) { try { if (v) sessionStorage.setItem(CHAVE, v); else sessionStorage.removeItem(CHAVE); } catch (_) { /* sem storage */ } }

export function lazyComRecarga(importar) {
  return React.lazy(() => importar().then((m) => { _gravar(null); return m; }).catch((err) => {
    if (ehFalhaDeCarregamento(err) && !_ler()) {
      _gravar('1');
      window.location.reload();
      return new Promise(() => {}); // a página vai recarregar
    }
    throw err;
  }));
}

export class LimiteDeErro extends React.Component {
  constructor(p) { super(p); this.state = { erro: null }; }
  static getDerivedStateFromError(erro) { return { erro }; }
  componentDidCatch(erro) {
    // eslint-disable-next-line no-console
    console.error('[LimiteDeErro]', erro);
  }
  render() {
    if (!this.state.erro) return this.props.children;
    const carregamento = ehFalhaDeCarregamento(this.state.erro);
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ maxWidth: 380, textAlign: 'center', fontFamily: 'inherit' }}>
          <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
            {carregamento ? 'O app foi atualizado' : 'Algo não carregou direito'}
          </div>
          <div style={{ fontSize: 14, opacity: 0.8, marginBottom: 16 }}>
            {carregamento ? 'Toque em recarregar para abrir a versão nova.' : 'Toque em recarregar para tentar de novo. Se continuar, fale com a equipe.'}
          </div>
          <button type="button" onClick={() => { _gravar(null); window.location.reload(); }}
            style={{ padding: '12px 22px', borderRadius: 10, border: 0, background: '#2F5CA6', color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
            Recarregar
          </button>
        </div>
      </div>
    );
  }
}
